module.exports = __webpack_public_path__ + "media/signup-react/cleaner-second-039e1a58.png";